import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Logo } from '../components/Logo';
import './Login.css';

export const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const { login, user } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Redirect if already logged in
  React.useEffect(() => {
    if (user) {
      if (user.role === 'user') navigate('/calendar', { replace: true });
      else if (user.role === 'coach') navigate('/coach/trainings', { replace: true });
      else if (user.role === 'admin') navigate('/admin/users', { replace: true });
    }
  }, [user, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const userData = await login({ email, password });
      // Navegar directamente según el rol del usuario
      if (userData.role === 'user') {
        navigate('/calendar', { replace: true });
      } else if (userData.role === 'coach') {
        navigate('/coach/trainings', { replace: true });
      } else if (userData.role === 'admin') {
        navigate('/admin/users', { replace: true });
      }
    } catch (err) {
      const error = err as { response?: { data?: { detail?: string } } };
      setError(error.response?.data?.detail || t('loginError'));
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card">
        <div className="login-header">
          <Logo className="login-logo" />
          <p>{t('login')}</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <Input
            type="email"
            label={t('email')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
            placeholder="usuario@ejemplo.com"
          />

          <Input
            type="password"
            label={t('password')}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            placeholder="••••••••"
          />

          {error && <div className="login-error">{error}</div>}

          <Button type="submit" fullWidth disabled={isLoading}>
            {isLoading ? t('loading') : t('login')}
          </Button>
        </form>
      </Card>
    </div>
  );
};
